<template>
    <div class="add-report-wrapper">
        <div class="report-content">
            <div class="report-item require" @click="handleChooseMember">
                <span class="label">当前成员</span>
                <input class="input" readonly placeholder="请选择" :value="curMember && curMember.name">
                <van-icon name="arrow" color="#CECECE" size="18px"/>
            </div>
            <div class="report-item require">
                <span class="label">地址</span>
                <input class="input" placeholder="请输入" v-model="reportForm.examineAddress">
            </div>
            <div class="report-item require" @click="handleDateTime">
                <span class="label">检查日期</span>
                <input class="input" readonly placeholder="请选择" :value="reportForm.reportDate">
                <van-icon name="arrow" color="#CECECE" size="18px"/>
            </div>
            <div class="group-title">
                <img src="../assets/img/eye.png" alt="">
                <span>视力情况</span>
            </div>
<!--            <div class="eys-param-item" style="margin-top: 25px">-->
<!--                <div class="title require"><span>裸眼视力5M</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.eyesight1"></div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.eyesight2"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title require"><span>矫正视力1.0</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.cva1"></div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.cva2"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title require"><span>电脑验光数据</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.optometry1"></div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.optometry2"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="eys-param-item" style="margin-top: 25px">
                <div class="title require"><span>眼压(mmHg)</span></div>
                <div class="input-group">
                    <div class="left">
                        <div class="label">左眼</div>
                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.iop1"></div>
                    </div>
                    <div class="right">
                        <div class="label">右眼</div>
                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.iop2"></div>
                    </div>
                </div>
            </div>
            <div class="eys-param-item">
                <div class="title require"><span>眼轴长度(mm)</span></div>
                <div class="input-group">
                    <div class="left">
                        <div class="label">左眼</div>
                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.axl1"></div>
                    </div>
                    <div class="right">
                        <div class="label">右眼</div>
                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.axl2"></div>
                    </div>
                </div>
            </div>
            <div class="eys-param-item">
                <div class="title require"><span>角膜曲率(D)</span></div>
                <div class="input-group">
                    <div class="left">
                        <div class="label">左眼</div>
                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.cornealCurvature1"></div>
                    </div>
                    <div class="right">
                        <div class="label">右眼</div>
                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.cornealCurvature2"></div>
                    </div>
                </div>
            </div>
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>角膜厚度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.cornealThickness1"></div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.cornealThickness2"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item" style="margin-top: 25px">-->
<!--                <div class="title"><span>前房深度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.chamberDepth1"></div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.chamberDepth2"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>晶体厚度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.crystalThickness1"></div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.crystalThickness2"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>玻璃体厚度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.vitreumThickness1"></div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.vitreumThickness2"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="eys-param-item">-->
<!--                <div class="title"><span>脉络膜厚度</span></div>-->
<!--                <div class="input-group">-->
<!--                    <div class="left">-->
<!--                        <div class="label">左眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.choroidThickness1"></div>-->
<!--                    </div>-->
<!--                    <div class="right">-->
<!--                        <div class="label">右眼</div>-->
<!--                        <div class="value"><input type="text" placeholder="请输入" v-model="reportForm.choroidThickness2"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="eys-param-item">
                <div class="title require"><span>上传眼底照片</span></div>
                <div class="input-group">
                    <div class="image-list">
                        <van-uploader preview-size="100px" v-model="fileList" :after-read="afterRead" :max-count="1"><img src="../assets/img/uploadpic.png" alt="" class="image-item" ></van-uploader>
                    </div>
                </div>
            </div>

            <div class="bottom-button-wrapper"><button class="submit-button" @click="handleSubmit">提交</button></div>
        </div>
        <van-popup v-model="showMemberPicker" round position="bottom">
            <van-picker
                    show-toolbar
                    :columns="members"
                    visible-item-count="3"
                    :default-index="indexShowMember"
                    value-key="name"
                    @cancel="showMemberPicker = false"
                    @confirm="handleConfirm"/>
        </van-popup>

        <van-popup v-model="showDateTimePicker" round position="bottom">
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="选择年月日"
                    @confirm="handleConfirmDatetime"
                    :min-date="minDate"
                    :max-date="maxDate"/>
        </van-popup>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import moment from 'moment';
    export default {
        name: "AddReportComp",
        data() {
            return {
                fileList: [],
                showMemberPicker: false,
                indexShowMember: undefined,
                showDateTimePicker: false,
                minDate: new Date(2020, 0, 1),
                maxDate: new Date(),
                currentDate: new Date(),
                reportForm: {
                    reportDate: undefined,
                    examineAddress: undefined,
                    eyesight1: undefined,
                    eyesight2: undefined,
                    cva1: undefined,
                    cva2: undefined,
                    optometry1: undefined,
                    optometry2: undefined,
                    iop1: undefined,
                    iop2: undefined,
                    axl1: undefined,
                    axl2: undefined,
                    cornealCurvature1: undefined,
                    cornealCurvature2: undefined,
                    cornealThickness1: undefined,
                    cornealThickness2: undefined,
                    chamberDepth1: undefined,
                    chamberDepth2: undefined,
                    crystalThickness1: undefined,
                    crystalThickness2: undefined,
                    vitreumThickness1: undefined,
                    vitreumThickness2: undefined,
                    choroidThickness1: undefined,
                    choroidThickness2: undefined,
                    image: undefined
                }
            }
        },
        computed: {
            curMember() {
                if (this.defaultMemberId) {
                    return this.members.find(item => item.id === this.defaultMemberId);
                }
                if (this.members.length > 0 && this.indexShowMember !== undefined) {
                    return this.members[this.indexShowMember];
                }
                return {};
            },
            ...mapState([
                'members'
            ])
        },
        props: {
            defaultMemberId: String
        },
        methods: {
            afterRead(file) {
                const self = this;
                file.status = 'uploading';
                file.message = '上传中...';
                return this.netUploadImage(file.file).then((image) => {
                    file.status = 'done';
                    self.reportForm.image = image;
                    return image;
                }).catch(() => {
                    file.status = 'failed';
                    file.message = '上传失败';
                });
            },
            handleConfirm(value, idx) {
                this.indexShowMember = idx;
                this.showMemberPicker = false;
            },
            handleChooseMember() {
                if (this.defaultMemberId) {
                    return;
                }
                this.showMemberPicker = true;
            },
            handleDateTime() {
                this.showDateTimePicker = true;
            },
            handleConfirmDatetime(value) {
                this.reportForm.reportDate = moment(value).format("YYYY-MM-DD");
                this.showDateTimePicker = false;
            },

            handleSubmit() {
                if (!this.curMember.id) {
                    this.postError('请选择成员');
                    return;
                }
                if (!this.reportForm.examineAddress) {
                    this.postError('请输入检测地址');
                    return;
                }
                if (!this.reportForm.reportDate) {
                    this.postError('请选择检查日期');
                    return;
                }
                // if (!this.reportForm.eyesight1 || !this.reportForm.eyesight2) {
                //     this.postError('请输入裸眼视力5M');
                //     return;
                // }
                // if (!this.isNumerical(this.reportForm.eyesight1) ||!this.isNumerical(this.reportForm.eyesight2)) {
                //     this.postError('裸眼视力5M，必须为数字');
                //     return;
                // }
                // if (!this.reportForm.cva1 || !this.reportForm.cva2) {
                //     this.postError('请输入矫正视力1.0');
                //     return;
                // }
                // if (!this.isNumerical(this.reportForm.cva1) ||!this.isNumerical(this.reportForm.cva2)) {
                //     this.postError('矫正视力1.0，必须为数字');
                //     return;
                // }
                // if (!this.reportForm.optometry1 || !this.reportForm.optometry2) {
                //     this.postError('请输入电脑验光数据');
                //     return;
                // }
                // if (!this.isNumerical(this.reportForm.optometry1) ||!this.isNumerical(this.reportForm.optometry2)) {
                //     this.postError('电脑验光数据，必须为数字');
                //     return;
                // }
                if (!this.reportForm.iop1 || !this.reportForm.iop2) {
                    this.postError('请输入眼压');
                    return;
                }
                if (!this.isNumerical(this.reportForm.iop1) ||!this.isNumerical(this.reportForm.iop2)) {
                    this.postError('眼压，必须为数字');
                    return;
                }
                if (!this.reportForm.axl1 || !this.reportForm.axl2) {
                    this.postError('请输入眼轴长度');
                    return;
                }
                if (!this.isNumerical(this.reportForm.axl1) ||!this.isNumerical(this.reportForm.axl2)) {
                    this.postError('眼轴长度，必须为数字');
                    return;
                }
                if (!this.reportForm.cornealCurvature1 || !this.reportForm.cornealCurvature2) {
                    this.postError('请输入角膜曲率');
                    return;
                }
                if (!this.isNumerical(this.reportForm.cornealCurvature1) ||!this.isNumerical(this.reportForm.cornealCurvature2)) {
                    this.postError('角膜曲率，必须为数字');
                    return;
                }
                // if (!this.isNumerical(this.reportForm.cornealThickness1) ||!this.isNumerical(this.reportForm.cornealThickness2)) {
                //     this.postError('角膜厚度，必须为数字');
                //     return;
                // }
                // if (!this.isNumerical(this.reportForm.chamberDepth1) ||!this.isNumerical(this.reportForm.chamberDepth2)) {
                //     this.postError('前房深度，必须为数字');
                //     return;
                // }
                // if (!this.isNumerical(this.reportForm.crystalThickness1) ||!this.isNumerical(this.reportForm.crystalThickness2)) {
                //     this.postError('晶体厚度，必须为数字');
                //     return;
                // }
                // if (!this.isNumerical(this.reportForm.vitreumThickness1) ||!this.isNumerical(this.reportForm.vitreumThickness2)) {
                //     this.postError('玻璃体厚度，必须为数字');
                //     return;
                // }
                // if (!this.isNumerical(this.reportForm.choroidThickness1) ||!this.isNumerical(this.reportForm.choroidThickness2)) {
                //     this.postError('脉络膜厚度，必须为数字');
                //     return;
                // }
                this.netAddReport({
                    memberId: this.curMember.id,
                    ...this.reportForm
                })
            },

            isNumerical(val) {
                if (!val) return true;
                return /^(-?\d+)(\.\d+)?$/.test(val.trim());
            },

            postError(message) {
                this.$toast.fail(message);
            },

            async netUploadImage(file) {
                try {
                    let {data} = await this.$req.uploadFile({
                        file: file
                    });
                    return data;
                } catch (e) {
                    //TODO
                }
                return null;
            },
            /**
             * 上传数据
             * @param params
             * @returns {Promise<void>}
             */
            async netAddReport(params) {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.insertReport(params);
                    if (!this.defaultMemberId) {
                        this.$router.back();
                    }
                    this.$emit("onSuccess");
                } catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            }
        }
    }
</script>